<template>
  <div class="loginPage">
    <div class="loginImg">
      <img class="logoImg" :src="logoImg" alt="" />
      <div class="name">研和智能数据中心</div>
      <div class="subTitle">创新是提升全人类健康的唯一路径。</div>
    </div>
    <div class="login-form">
      <el-form
        class="form-content"
        :model="loginForm"
        :rules="rules"
        ref="loginForm"
        label-position="top"
        label-width="80px"
        @submit.native.prevent
      >
        <div class="title">登录</div>

        <el-form-item label="用户手机号" prop="userName">
          <el-input
            key="username"
            autocomplete="off"
            type="text"
            maxlength="20"
            placeholder="请输入注册手机号"
            :validate-event="false"
            v-model.trim="loginForm.userName"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input
            auto-complete="new-password"
            autocomplete="off"
            key="password"
            type="password"
            :validate-event="false"
            placeholder="请输入密码"
            v-model.trim="loginForm.password"
            show-password
          >
          </el-input>
        </el-form-item>

        <el-form-item class="sldentify" label="验证码" prop="inputCode">
          <div style="display: flex" id="atilposition">
            <el-input
              type="text"
              ref="inputCode"
              v-model.trim="loginForm.inputCode"
              placeholder="请输入验证码"
              :validate-event="false"
              clearable
              @keyup.enter.native="handleLogin"
            ></el-input>
            <span @click="createCode" id="spancode">
              <Sldentify :identifyCode="code"></Sldentify>
            </span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :disabled="disabled"
            style="width: 100%; margin-bottom: 30px"
            @click="handleLogin"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
      <div class="companyCode">
        研和智能科技（杭州）有限公司 浙ICP备19049590号-1
      </div>
    </div>
  </div>
</template>

<script>
import { saveToken, saveUserName } from "../../utils/auth";
import { handleResponse } from "../../utils/response";
import Sldentify from "./component/Sldentify.vue";

import userApi, { loginAdminUser, test } from "../../api/userApi";

export default {
  name: "Login",
  components: {
    Sldentify,
  },
  methods: {
    createCode() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      // 设置验证码长度，
      for (let i = 0; i < 4; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      this.code = text;
    },
    getVipType() {
      this.$get("/vip/all").then((res) => {
        if (res.data.code === 1000) {
          const list = res.data.data.list;
          const result = Object.fromEntries(
            list.map((item) => [item._id, item.name])
          );
          localStorage.setItem("VIP_ALL", JSON.stringify(result));
        }
      });
    },
    handleLogin() {
      this.$get("/dict/all", {}).then((res) => {
        console.log("获取到的字典项", res.data.data.list);
        localStorage.setItem("DICT_ALL", JSON.stringify(res.data.data.list));
      });
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          loginAdminUser(this.loginForm).then((response) => {
            localStorage.setItem(
              "userInfo",
              JSON.stringify(response.data.data)
            );
            this.$store.commit("changeUserInfo", response.data.data);
            var code = response.data.code;
            if (code != 1000) {
              this.$message.error(response.data.msg);
            }
            handleResponse(
              response,
              (data) => {
                var token = data.token;
                saveToken(token);
                saveUserName(data.userName);
                // console.log("response==", response.data.data.permissions);
                this.getVipType();
                const permissions = response.data.data.permissions;
                this.$store.dispatch("updatePermissions", permissions);
                if (permissions.includes("all")) {
                  this.$router.push({
                    path: "/",
                    query: {},
                  });
                  return;
                }
                this.projectConfig.LEFT_MENU.some((item) => {
                  if (!permissions.includes(item.code)) {
                    return false; // 继续检查下一个
                  }

                  if (item.path) {
                    this.$router.push({ path: item.path, query: {} });
                    return true; // 停止循环
                  }

                  if (item.children) {
                    return item.children.some((child) => {
                      if (permissions.includes(child.code) && child.path) {
                        this.$router.push({ path: child.path, query: {} });
                        return true; // 停止内层循环
                      }
                      return false; // 继续检查下一个
                    });
                  }
                  return false; // 继续检查下一个
                });
              },
              (error) => {}
            );
          });
        }
      });
    },
  },
  data() {
    const checkInputCode = (rule, value, callback) => {
      if (value.toLowerCase() !== this.code.toLowerCase()) {
        this.loginForm.inputCode = "";
        this.createCode();
        callback(new Error("验证码错误"));
      } else {
        return callback();
      }
    };
    return {
      logoImg: require("@/assets/images/yhe@2x.png"),
      code: "",
      loginForm: {
        userName: "",
        password: "",
        // userName: "13817400952",
        // password: "yanhe123",
        inputCode: "",
      },
      rules: {
        userName: [
          {
            pattern:
              /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        password: [
          {
            pattern:
              /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+-/~=?])[A-Za-z\d!@#$%^&*()_+-/~=?]{8,16}$/,
            message:
              "请输入8~16位密码且至少包含一位数字和一位字母和一位特殊字符",
            trigger: "blur",
          },
        ],
        inputCode: [{ validator: checkInputCode, trigger: "blur" }],
      },
    };
  },
  computed: {
    disabled() {
      return (
        !this.loginForm.userName ||
        !this.loginForm.password ||
        !this.loginForm.inputCode
      );
    },
  },
  mounted() {
    this.createCode();
  },
};
</script>

<style lang="less">
.loginPage {
  display: flex;
}
.loginImg {
  width: 60%;
  height: 100vh;
  background-image: url("../../assets/images/pic_loginbg2x.png");
  background-size: 100% 100%;
  padding-left: 100px;
}
.logoImg {
  width: 112px;
  height: 60px;
  margin-top: 120px;
}
.name {
  margin-top: 40px;
  font-size: 56px;
  font-weight: 700;
  padding-bottom: 40px;
}
.subTitle {
  font-size: 20px;
  color: #4e5969;
}
.login-form {
  position: relative;
  width: 40%;
  height: 100vh;
  /* height: 300px; */
  // padding: 0 50px;
  background-color: #fff;
}
.form-content {
  // margin-top: 150px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.title {
  font-size: 36px;
  /* color: #eee; */
  text-align: center;
  padding-top: 30px;
  margin-bottom: 30px;
}
.companyCode {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  color: #86909c;
}
/* .sldentify{
    display: flex;
  } */

/*.el-form-item {*/
/*  height: 40px;*/
/*  width: 100%;*/
/*  color: #454545;*/
/*}*/

/*.el-input__inner {*/
/*  border: 0px;*/
/*  border-radius: 0px;*/
/*  color: #fff;*/
/*  width: 100%;*/
/*  !*height: 100%;*!*/
/*  min-height: 100%;*/
/*  margin: auto;*/
/*}*/
</style>
